import { ReferenceToSubmit } from 'features/Connect/features/ConnectATSIntegration/HiringRequests/components/CandidateFeedback/components/Panes/Create/Reference/AddContact/types';
import { Reference as ReferenceResponse } from 'types';
import { BaseNimbleAPI } from './baseAPI';

class ReferencesAPI extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/references' };
  }

  async createReference(reference: ReferenceToSubmit): Promise<ReferenceResponse> {
    const response = await this.post('/', reference);
    return response.data;
  }

  async getReferences(candidateId: number): Promise<ReferenceResponse> {
    const url = `/?candidate_id=${candidateId}`;
    const response = await this.get(url, candidateId);
    return response.data;
  }
}

export default new ReferencesAPI();
